import { render, staticRenderFns } from "./ReasonSelect.vue?vue&type=template&id=effc03d2&"
import script from "./ReasonSelect.vue?vue&type=script&lang=js&"
export * from "./ReasonSelect.vue?vue&type=script&lang=js&"
import style0 from "./ReasonSelect.vue?vue&type=style&index=0&id=effc03d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports